import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { tabListener } from "../../../lib/events/tabListener";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { OkIcon, SquareIcon } from "../../../internal/icons/16px";
import { isEdge, isFirefox, isIE11 } from "../../../lib/client";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles, globalClasses } from "../Checkbox.styles";
/**
 * Все свойства, кроме перечисленных, `className` и `style` передаются в `input`.
 */

export var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Checkbox, _React$Component);

  function Checkbox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      focusedByTab: false,
      indeterminate: _this.props.initialIndeterminate || false
    };
    _this.theme = void 0;
    _this.input = void 0;

    _this.componentDidMount = function () {
      if (_this.state.indeterminate && _this.input) {
        _this.input.indeterminate = true;
      }
    };

    _this.setIndeterminate = function () {
      _this.setState({
        indeterminate: true
      });

      if (_this.input) {
        _this.input.indeterminate = true;
      }
    };

    _this.resetIndeterminate = function () {
      _this.setState({
        indeterminate: false
      });

      if (_this.input) {
        _this.input.indeterminate = false;
      }
    };

    _this.renderMain = function (props) {
      var _cx, _cx3, _cx4;

      var error = props.error,
          warning = props.warning,
          onMouseEnter = props.onMouseEnter,
          onMouseLeave = props.onMouseLeave,
          onMouseOver = props.onMouseOver,
          onValueChange = props.onValueChange,
          type = props.type,
          initialIndeterminate = props.initialIndeterminate,
          rest = _objectWithoutPropertiesLoose(props, ["error", "warning", "onMouseEnter", "onMouseLeave", "onMouseOver", "onValueChange", "type", "initialIndeterminate"]);

      var isIndeterminate = _this.state.indeterminate;
      var rootClass = cx((_cx = {}, _cx[styles.root(_this.theme)] = true, _cx[styles.rootFallback()] = isIE11 || isEdge, _cx[styles.rootChecked(_this.theme)] = props.checked || isIndeterminate, _cx[styles.disabled(_this.theme)] = Boolean(props.disabled), _cx));

      var inputProps = _extends({}, rest, {
        type: 'checkbox',
        className: styles.input(),
        onChange: _this.handleChange,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur,
        onClick: _this.handleClick,
        ref: _this.inputRef
      });

      var caption = null;

      if (_this.props.children) {
        var _cx2;

        var captionClass = cx((_cx2 = {}, _cx2[styles.caption(_this.theme)] = true, _cx2[styles.captionIE11()] = isIE11 || isEdge, _cx2));
        caption = /*#__PURE__*/React.createElement("span", {
          className: captionClass
        }, _this.props.children);
      }

      var iconClass = cx((_cx3 = {}, _cx3[styles.iconUnchecked()] = !props.checked && !isIndeterminate, _cx3[styles.iconFixBaseline()] = isFirefox || isIE11 || isEdge, _cx3));
      var box = /*#__PURE__*/React.createElement("span", {
        className: cx(styles.box(_this.theme), globalClasses.box, (_cx4 = {}, _cx4[styles.boxChecked(_this.theme)] = Boolean(props.checked) || isIndeterminate, _cx4[styles.boxWarning(_this.theme)] = Boolean(props.warning), _cx4[styles.boxError(_this.theme)] = Boolean(props.error), _cx4[styles.boxFocus(_this.theme)] = _this.state.focusedByTab, _cx4[styles.boxDisabled(_this.theme)] = Boolean(props.disabled), _cx4))
      }, isIndeterminate && /*#__PURE__*/React.createElement(SquareIcon, {
        className: iconClass
      }) || /*#__PURE__*/React.createElement(OkIcon, {
        className: iconClass
      }));
      return /*#__PURE__*/React.createElement("label", {
        className: rootClass,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseOver: onMouseOver
      }, /*#__PURE__*/React.createElement("input", inputProps), box, caption);
    };

    _this.handleFocus = function (e) {
      if (!_this.props.disabled) {
        // focus event fires before keyDown eventlistener
        // so we should check tabPressed in async way
        requestAnimationFrame(function () {
          if (tabListener.isTabPressed) {
            _this.setState({
              focusedByTab: true
            });
          }
        });

        if (_this.props.onFocus) {
          _this.props.onFocus(e);
        }
      }
    };

    _this.handleBlur = function (e) {
      _this.props.onBlur == null ? void 0 : _this.props.onBlur(e);

      _this.setState({
        focusedByTab: false
      });
    };

    _this.inputRef = function (ref) {
      _this.input = ref;
    };

    _this.handleChange = function (event) {
      var checked = event.currentTarget.checked;
      _this.props.onValueChange == null ? void 0 : _this.props.onValueChange(checked);

      _this.resetIndeterminate();

      _this.props.onChange == null ? void 0 : _this.props.onChange(event);
    };

    _this.handleClick = function (e) {
      _this.props.onClick == null ? void 0 : _this.props.onClick(e); // support IE11's and old Edge's special behavior
      // https://github.com/jquery/jquery/issues/1698

      if (_this.state.indeterminate && (isIE11 || isEdge)) {
        _this.resetIndeterminate(); // simulate correct behavior only if onValueChange is used
        // because we cant simulate real native onChange event


        if (_this.props.onValueChange && _this.input) {
          var checked = !_this.input.checked;

          if (_this.props.checked === undefined) {
            // in case of uncontrolled mode
            _this.input.checked = checked;
          }

          _this.props.onValueChange(checked);
        }
      }
    };

    return _this;
  }

  var _proto = Checkbox.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.resetIndeterminate();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this2.props, _this2.renderMain);
    });
  }
  /**
  * @public
  */
  ;

  _proto.focus = function focus() {
    var _this$input;

    tabListener.isTabPressed = true;
    (_this$input = this.input) == null ? void 0 : _this$input.focus();
  }
  /**
  * @public
  */
  ;

  _proto.blur = function blur() {
    var _this$input2;

    (_this$input2 = this.input) == null ? void 0 : _this$input2.blur();
  }
  /**
  * Установить промежуточное значение
  * @public
  */
  ;

  return Checkbox;
}(React.Component);
Checkbox.__KONTUR_REACT_UI__ = 'Checkbox';
Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  warning: PropTypes.bool,
  onValueChange: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func
};